export default {
  order_status_toast: {
    order_reviewed: '#{{number}} Deine Bestellung wurde gesehen',
    order_confirmed: '#{{number}} Bestellung bestätigt {{time}}',
    order_preparation_up_time_changed: '#{{number}} {{type}} geändert auf {{time}}',
    serving_time_changed: '#{{number}} Deine Bestellung wird um {{time}} serviert',
    order_preparing: 'Deine Bestellung #{{number}} wird zubereitet',
    order_rejected: '#{{number}} Bestellung storniert',
  },
  order_type: {
    pickup: 'Abholung',
    delivery: 'Lieferung',
  },
};
